<template>
	<div class="d-flex flex-fill">
		<div class="d-flex align-items-center">
			<div class="dataTables_info pt-0 mr-2" id="DataTables_Table_0_info" role="status" aria-live="polite">Page <strong>{{ pagination.current_page }}</strong> of <strong>{{ pagination.last_page }}</strong> - <strong>{{ pagination.total }}</strong> results</div>
			
			<div v-if="perPage" class="form-inline justify-content-end mr-2">
				Items per page:
				<select id="items-per-page" class="form-control form-control-sm ml-1" name="per-page" v-model="perPageModel">
					<option :value="20">20</option>
					<option :value="50">50</option>
					<option :value="100">100</option>
					<option :value="200">200</option>
					<option v-if="massEdit" :value="1000">1000</option>
				</select>
			</div>
		</div>
		<div class="flex-grow-1 dataTables_paginate paging_simple_numbers mr-3">
				<ul class="pagination justify-content-end mb-0">
					<li class="paginate_button page-item previous" :class="{'disabled': !pagination.current_page || pagination.current_page <= 1}">
						<a class="page-link"
							href="javascript:void(0)"
							aria-label="First page"
							@click.prevent="changePage(1)"
						>
							<span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span>
						</a>
					</li>
					<li class="paginate_button page-item previous" :class="{'disabled': !pagination.current_page || pagination.current_page <= 1}">
						<a class="page-link"
							href="javascript:void(0)"
							aria-label="Previous"
							@click.prevent="changePage(pagination.current_page - 1)"
						>
							<span aria-hidden="true"><i class="fa fa-angle-left"></i></span>
						</a>
					</li>
					<li class="paginate_button page-item"
						:key="page"
						v-for="page in pagesNumber"
						:class="{ active: page == pagination.current_page }"
					>
						<a class="page-link"
							href="javascript:void(0)"
							@click.prevent="changePage(page)"
							>{{ page }}</a
						>
					</li>
					<li class="paginate_button page-item next" :class="{'disabled': pagination.current_page >= pagination.last_page}">
						<a class="page-link"
							href="javascript:void(0)"
							aria-label="Next"
							@click.prevent="changePage(pagination.current_page + 1)"
						>
							<span aria-hidden="true"><i class="fa fa-angle-right"></i></span>
						</a>
					</li>
					<li class="paginate_button page-item next" :class="{'disabled': pagination.current_page >= pagination.last_page}">
						<a class="page-link"
							href="javascript:void(0)"
							aria-label="Last Page"
							@click.prevent="changePage(pagination.last_page)"
						>
							<span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span>
						</a>
					</li>
				</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'pagination',
		props: {
			pagination: {
				type: Object,
				required: true
			},
			offset: {
				type: Number,
				default: 4
			},
			massEdit: {
				type: Boolean,
				required: false,
			},
			perPage: {
				type: Number,
				require: false,
			},
		},
    data() {
		  return {
        current_page: 1
		  }
    },
		computed: {
			perPageModel: {
				get() {
					return this.perPage;
				},
				set(value) {
					this.$emit('update-per-page', { display: value });
				}
			},
			pagesNumber() {
				if (!this.pagination.to) {
					return [];
				}
				let from = this.pagination.current_page - this.offset;
				if (from < 1) {
					from = 1;
				}
				let to = from + this.offset * 2;
				if (to >= this.pagination.last_page) {
					to = this.pagination.last_page;
				}
				let pagesArray = [];
				for (let page = from; page <= to; page++) {
					pagesArray.push(page);
				}
				return pagesArray;
			}
		},
		methods: {
			changePage(page) {
				this.pagination.current_page = page;
				this.$emit('paginate', page);
			}
		}
	};
</script>
<style>

</style>